import { motion } from "framer-motion";
import { Globe2, FileCheck2, Ship } from "lucide-react";
import { Seo } from "@/components/Seo";
import { EnquiryForm } from "@/components/EnquiryForm";
import { IMAGES } from "@/data/products";

const fade = {
  initial: { opacity: 0, y: 24 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-60px" },
  transition: { duration: 0.6, ease: "easeOut" },
};

export default function InternationalExport() {
  return (
    <div data-testid="export-page">
      <Seo
        title="International Denim Export from India — Shineni India"
        description="Made-in-India denim jeans export for importers, buying houses and fashion brands. Share your destination and specifications with Shineni India, Faridabad."
      />

      <section className="relative border-b border-border">
        <img src={IMAGES.texture} alt="Indigo denim fabric texture" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-indigo-deep/80" />
        <div className="relative mx-auto max-w-7xl px-4 py-20 sm:px-6 sm:py-24">
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-gold">Made in India · Shipping worldwide</p>
          <h1 className="mt-3 max-w-3xl font-display text-4xl font-semibold text-white sm:text-5xl">
            International export
          </h1>
          <p className="mt-4 max-w-2xl text-white/80">
            For importers, buying houses and fashion brands sourcing denim from India. Share your
            destination, quantities and specifications — we respond with a program-specific offer.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6">
        <div className="grid gap-6 sm:grid-cols-3">
          {[
            { icon: Globe2, t: "Import-ready production", d: "Denim programs produced to your market's fits, size charts and labelling requirements." },
            { icon: FileCheck2, t: "Documentation support", d: "Export documentation prepared per shipment requirements and agreed Incoterms." },
            { icon: Ship, t: "Dispatch to your port", d: "Packed, cartoned and dispatched to your nominated port or freight forwarder." },
          ].map((s) => (
            <motion.div key={s.t} {...fade} className="border border-border bg-white p-8">
              <s.icon className="h-7 w-7 text-gold" />
              <h2 className="mt-5 font-display text-lg font-semibold text-indigo">{s.t}</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground/70">{s.d}</p>
            </motion.div>
          ))}
        </div>
        <motion.p {...fade} className="mt-8 max-w-3xl text-sm text-muted-foreground">
          Export references, compliance documents and program-specific terms are shared directly
          with serious buyers during the quotation process.
        </motion.p>
      </section>

      <section className="mx-auto max-w-7xl px-4 pb-20 sm:px-6">
        <motion.div {...fade} className="mx-auto max-w-3xl">
          <EnquiryForm
            variant="export"
            title="Export enquiry"
            subtitle="Tell us your destination and specifications — we reply on email or WhatsApp."
          />
        </motion.div>
      </section>
    </div>
  );
}
